const paymentPaths = {
  merchantAccounts: '/payment/merchant-accounts',
  corporations: '/payment/corporations',
  banks: '/payment/banks',
  pools: '/payment/pools',
  poolDetails: (id = ':id') => `/payment/pools/${id}`,
  rebillPools: '/payment/rebill-pools',
  newRebillPool: '/payment/rebill-pools/new',
  editRebillPool: (id = ':id') => `/payment/rebill-pools/${id}/edit`,
  binRoutings: '/payment/bin-routings',
  binRoutingDetails: (id = ':id') => `/payment/bin-routings/${id}`,
  cardBins: '/payment/bin-routings/card-bins',
  badBins: '/payment/bin-routings/bad-bins',
  settings: '/payment/reprocessing',
  retries: '/payment/reprocessing/programs',
  reprocflowMapping: '/payment/reprocessing/initials',
  rebillflowMapping: '/payment/reprocessing/subscriptions',
  upsell: '/payment/reprocessing/upsells',
  merchantProfiles: '/payment/payment-routing',
  merchantProfileDetails: (id = ':id') => `/payment/payment-routing/${id}`,
};

export default paymentPaths;
